import template from './templates';

const DEFAULT_CONTEXT = {
    logo: {
        alt: 'UPS'
    },
    text: 'UPS, the UPS brand mark, and the Color Brown are trademarks of United Parcel Service of America, Inc. All Rights Reserved'
};

const DEFAULT_OPTIONS = {
    replaceOriginEl: false
};

export default class UpsCopyright {
    constructor($originEl, options, context) {
        options = { ...DEFAULT_OPTIONS, ...options };
        context = { ...DEFAULT_CONTEXT, ...context };

        const $parsed = $($.parseHTML(template));
        this.$el = $parsed;
        this.$originEl = $originEl;

        this.$logo = this.$el.find('[data-region="logo"]');
        this.$text = this.$el.find('[data-region="text"]');

        this.replaceOriginEl = options.replaceOriginEl;

        this.context = context;

        this.init();
    }

    init() {
        this.renderRegions();
    }

    render() {
        if(this.$originEl) {
            if(this.replaceOriginEl) {
                this.$originEl.replaceWith(this.$el);
            } else {
                this.$originEl.html(this.$el);
            }
        }

        return this.$el;
    }

    renderRegions() {
        if(this.context.logo.url) {
            const img = document.createElement('img');
            img.alt = this.context.logo.alt;
            img.src = this.context.logo.url;
            this.$logo.html(img);
        } else {
            this.$logo.hide();
        }

        this.$text.html(this.context.text);
    }
}
